import { Modal, Container } from "react-bootstrap";
import React from "react";
import { Row, Col, Button } from "antd";

function ViewModal(props) {
  return (
    <div>
      <Modal show={props.show} onHide={props.onHide} size={props.size} centered>
        <Modal.Header closeButton />
        <Modal.Body>
          <div className="col-sm-12">
            {props.withHeader && (
              <div className="col-sm-12">
                <span className="custom-modal-body-title">
                  {" "}
                  VIEW {props.title}{" "}
                </span>
              </div>
            )}
            <Container fluid className="modal-cont justify-content-center">
              {props.children}
            </Container>
            {props.withButtons && (
              <Row className="mt-4 d-flex justify-content-end">
                <Col xs={12}>
                  <Row className=" w-100">
                    <Col xs={12}>
                      <Button
                        // type="primary"
                        className="button-secondary me-3 w-100"
                        onClick={props.onHide}
                      >
                        Close
                      </Button>
                    </Col>
                    <Col xs={12}>
                      <Button
                        className="button-primary w-100"
                        onClick={props.onEdit}
                      >
                        Edit
                      </Button>
                    </Col>
                  </Row>
                </Col>
              </Row>
            )}
          </div>
        </Modal.Body>
      </Modal>
    </div>
  );
}

ViewModal.defaultProps = {
  title: "",
  type: "",
  size: "xl",
  withButtons: false,
  withHeader: false,
  show: () => {},
  onHide: () => {},
  onEdit: () => {},
};

export default ViewModal;
